<script setup lang="ts">
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';

const { title, content } = defineProps<{
  title?: string;
  content: string;
}>();
</script>

<template>
  <sl-tooltip
    hoist="true"
    distance="4"
  >
    <div slot="content">
      <h5
        v-if="title"
        class="title font-accent gap-s-1"
      >
        {{ title }}
      </h5>
      <div
        class="content font-accent text-sm"
        v-html="content"
      />
    </div>
    <slot />
  </sl-tooltip>
</template>

<style scoped lang="postcss">
sl-tooltip {
  --sl-tooltip-arrow-size: 0;
  --max-width: 300px;

  &::part(body) {
    margin: 0 var(--space-xs-var_03, 4px);
    padding: var(--space-s-var_02, 12px);
    border-radius: var(--border-radius-default);
    background-color: var(--colors-neutral-dark_blue-60);
  }
}

.title {
  margin-bottom: var(--space-s-var_01, 8px);
  color: var(--color-white-100);
}

.content {
  color: var(--color-white-50);
}
</style>
